import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';

interface ScrollbarProps {
  thumbScrollLeft: number;
  thumbWidthFactor: number;
  className?: string;
}

export const Scrollbar: React.FC<ScrollbarProps> = ({
  thumbScrollLeft,
  thumbWidthFactor,
  className,
}) => {
  if (thumbWidthFactor === 1) {
    return null;
  }

  return (
    <ScrollBar className={className}>
      <ScrollThumb
        thumbWidthFactor={thumbWidthFactor}
        thumbScrollLeft={thumbScrollLeft}
      />
    </ScrollBar>
  );
};

const scrollBarHeight = 2;

const ScrollBar = styled.div`
  width: 100%;
  height: ${scrollBarHeight}px;
  left: 0;
  position: absolute;
  border-radius: 7px;
  bottom: 0px;
  background-color: ${COLORS.Grey3};
`;

const ScrollThumb = styled.div<{
  thumbScrollLeft: number;
  thumbWidthFactor: number;
}>`
  position: absolute;
  width: calc(100vw / ${({thumbWidthFactor}) => thumbWidthFactor});
  height: ${scrollBarHeight}px;
  transform: translateX(
    calc(100vw / ${({thumbScrollLeft}) => thumbScrollLeft})
  );
  transition: transform 0.3s ease-in-out;
  background-color: ${COLORS.Black};
`;
